/* eslint-disable no-use-before-define no-throw-literal */
import React from 'react'
import {FrameIn, getConfig, getBrand, setBackFrom, trackPage, getOwaTcdaoContext} from '../../twd'

export default ({cusip, action='B', comm='', comm_basis='', acctNo='', qty='', sourceAction='', sourceOrderNo='', price='', from} = {}) => {
    if (!cusip) {
        throw new Error('tools.bond-order: missing cusip')
    }

    trackPage('tools.bond-order')

    let sp = new URLSearchParams()
    sp.set('p_cusip', cusip)
    sp.set('p_action', action)
    sp.set('p_acct_no', acctNo)
    sp.set('p_qty_bond', qty)
    if (comm) sp.set('p_comm', comm)
    if (comm_basis) sp.set('p_comm_basis', comm_basis)
    if (price) {
        sp.set('p_price', price)
        sp.set('p_price_type', 1)
    }
    if (sourceAction) sp.set('p_source_action', sourceAction)
    if (sourceOrderNo) sp.set('p_source_order_no', sourceOrderNo)

    let base = getConfig('bw_service_host') + '/' + getBrand()
    let owaTcDaoContext = getOwaTcdaoContext()
    let url = `${base}/${owaTcDaoContext}/pkg_order_bond.output?${sp.toString()}`

    if (from) setBackFrom('tools.bond-order', from)

    return <React.Fragment>
        <FrameIn dataName="tools-bond-order-frame" src={url} />
        </React.Fragment>
}


// WEBPACK FOOTER //
// ./src/tools-and-resources/tools/bond-order.js